"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Colgroup(_ref) {
  var columns = _ref.columns,
      colgroup = _ref.colgroup;

  if (colgroup && colgroup.length === columns.length) {
    return _react.default.createElement("colgroup", null, colgroup.map(function (c, i) {
      return _react.default.createElement("col", {
        key: columns[i].key,
        style: {
          width: c
        }
      });
    }));
  }

  return _react.default.createElement("colgroup", null, columns.map(function (c) {
    return _react.default.createElement("col", {
      key: c.key,
      style: {
        width: c.width
      }
    });
  }));
}

Colgroup.propTypes = {
  columns: _propTypes.default.array.isRequired,
  colgroup: _propTypes.default.array
};
Colgroup.defaultProps = {
  colgroup: undefined
};
var _default = Colgroup;
exports.default = _default;